module.exports = __webpack_public_path__ + "static/media/67.ea0f1a53.jpg";